import { api } from 'common';

export type FlowDecorationColor = api.FlowDefinition.FlowDecorationColor;
export const FlowDecorationColor = api.FlowDefinition.FlowDecorationColor;
export type StickyNoteFontSize = api.FlowDefinition.StickyNoteFontSize;
export const StickyNoteFontSize = api.FlowDefinition.StickyNoteFontSize;

export interface FlowDecorationColorProps {
  backgroundColor: string;
  borderColor: string;
}

export const FLOW_DECORATION_COLORS: Record<FlowDecorationColor, FlowDecorationColorProps> = {
  [FlowDecorationColor.Yellow]: {
    backgroundColor: '#ffefcc',
    borderColor: '#ffbe33',
  },
  [FlowDecorationColor.Pink]: {
    backgroundColor: 'hsla(339, 85%, 90%, 1)',
    borderColor: 'hsla(338, 85%, 55%, 1)',
  },
  [FlowDecorationColor.Green]: {
    backgroundColor: '#d7f4e3',
    borderColor: '#61d190',
  },
  [FlowDecorationColor.Blue]: {
    backgroundColor: '#ccdfff',
    borderColor: '#3381ff',
  },
  [FlowDecorationColor.Purple]: {
    backgroundColor: 'hsla(261, 91%, 91%, 1)',
    borderColor: 'hsla(261, 90%, 60%, 1)',
  },
  [FlowDecorationColor.Orange]: {
    backgroundColor: 'hsla(25, 100%, 85%, 1)',
    borderColor: 'hsla(25, 100%, 49%, 1)',
  },
};

export const FLOW_DECORATION_SEMI_TRANSPARENT_COLORS: Record<
  FlowDecorationColor,
  FlowDecorationColorProps
> = {
  [FlowDecorationColor.Yellow]: {
    backgroundColor: '#ffefcc80',
    borderColor: '#ffbe3380',
  },
  [FlowDecorationColor.Pink]: {
    backgroundColor: 'hsla(339, 85%, 90%, 0.5)',
    borderColor: 'hsla(338, 85%, 55%, 0.5)',
  },
  [FlowDecorationColor.Green]: {
    backgroundColor: '#d7f4e380',
    borderColor: '#61d19080',
  },
  [FlowDecorationColor.Blue]: {
    backgroundColor: '#ccdfff80',
    borderColor: '#3381ff80',
  },
  [FlowDecorationColor.Purple]: {
    backgroundColor: 'hsla(261, 91%, 91%, 0.5)',
    borderColor: 'hsla(261, 90%, 60%, 0.5)',
  },
  [FlowDecorationColor.Orange]: {
    backgroundColor: 'hsla(25, 100%, 85%, 0.5)',
    borderColor: 'hsla(25, 100%, 49%, 0.5)',
  },
};

export const STICKY_NOTE_FONT_SIZES: Record<StickyNoteFontSize, string> = {
  [StickyNoteFontSize.Small]: '12px',
  [StickyNoteFontSize.Medium]: '16px',
  [StickyNoteFontSize.Large]: '18px',
};
